export default __webpack_public_path__ + "static/media/NotoSansKR-Light.7d4ce2f6.otf";